<!--
 * @Author: alex.dai
 * @Date: 2023-04-20 15:43:33
 * @LastEditors: alex.dai
 * @LastEditTime: 2023-04-20 15:59:09
 * @FilePath: /new-frontend/src/components/order/ManualOrder.vue
 * @Description:
-->
<template>
  <Modal
    class="create-update-modal"
    :mask-closable="false"
    :closable="false"
    :title="`手动下单(测试用)`"
    v-model="modal">
    <Form ref="handleForm" :model="handleForm" :rules="handleValidate" :label-width="130">
      <Row>
				<Col :sm="24" :xs="24">
					<FormItem label="充值账户:" prop="account">
            <Input v-model.trim="handleForm.account" placeholder="请输入" />
          </FormItem>
				</Col>
				<Col :sm="24" :xs="24">
					<FormItem label="代理商商品编号:" prop="agentCommodityId">
            <Select v-model="handleForm.agentCommodityId" clearable style="width: 100%;" filterable>
              <Option v-for="item in agentComList" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
          </FormItem>
				</Col>
				<Col :sm="24" :xs="24">
					<FormItem label="商户订单号:" prop="outTradeNo">
            <Input v-model.trim="handleForm.outTradeNo"  placeholder="请输入"/>
          </FormItem>
				</Col>
      </Row>
    </Form>
    <div slot="footer">
      <Button type="text" @click="hide" :disabled="loading">取消</Button>
      <Button type="primary" :loading="loading" @click="submit">确定</Button>
    </div>
  </Modal>
</template>

<script>
import api from '../../api'

export default {
  name: 'ManualOrder',
  data () {
    return {
      modal: false,
      loading: false,
      handleForm: {
        account: null,
        agentCommodityId: null,
        outTradeNo: null
      },
      agentComList: [],
      handleValidate: {
        name: [
          { required: true, whitespace: true, message: '请输入供应商名称', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
  },
  methods: {
    setTimeDateFmt (s) {
      return s < 10 ? '0' + s : s
    },
    createordernum () {
      const now = new Date()
      let month = now.getMonth() + 1
      let day = now.getDate()
      let hour = now.getHours()
      let minutes = now.getMinutes()
      let seconds = now.getSeconds()
      month = this.setTimeDateFmt(month)
      day = this.setTimeDateFmt(day)
      hour = this.setTimeDateFmt(hour)
      minutes = this.setTimeDateFmt(minutes)
      seconds = this.setTimeDateFmt(seconds)
      return now.getFullYear().toString() + month.toString() + day + hour + minutes + seconds + (Math.round(Math.random() * 1000000)).toString()
    },
    show () {
      this.modal = true
      this.handleForm.outTradeNo = 'BF_' + this.createordernum()
      api.agent.agentCommoditys().then(res => {
        this.agentComList = res.data.map(item => {
          return {
            value: item.id,
            label: item.commodityName
          }
        })
      }).catch(err => {
        console.log(err)
      })
    },
    hide () {
      this.$refs['handleForm'].resetFields()
      this.loading = false
      this.modal = false
    },
    submit () {
      this.$refs['handleForm'].validate((valid) => {
        if (valid) {
          this.submitForm()
        } else {
          this.$Message.error('请填写必填项目!')
        }
      })
    },
    submitForm () {
      // console.log('修改参数', this.handleForm)
      let submitApi = api.order.uniManualOrder
      this.loading = true
      submitApi(this.handleForm).then(res => {
        this.$emit('success', this.action, {
          ...this.handleForm
        })
        this.$Message.success('修改成功！')
        this.hide()
      }).catch(err => {
        this.$Message.error('修改失败：' + err.message)
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>
